@if (fieldSet.includes(ServiceDataFields.VanishingTwinSyndrome)) {
  <ng-container formGroupName="vanishingTwinSyndrome">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-sm-6 col-md-4 mb-1">
            <label for="vanishingTwinSyndromeIsDetected">{{
              'serviceData.form.vanishingTwinSyndrome' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-6 col-md-8">
            <div class="col-9">
              <div class="form-check form-check-inline form-check-lg">
                <input
                  id="vanishingTwinSyndromeIsDetectedYes"
                  class="form-check-input me-2"
                  type="radio"
                  formControlName="isDetected"
                  [attr.data-cy]="
                    ServiceDataFields.VanishingTwinSyndrome + '-radio-yes'
                  "
                  [value]="true"
                />
                <label
                  class="form-check-label"
                  for="vanishingTwinSyndromeIsDetectedYes"
                >
                  {{ 'common.yes' | translate }}
                </label>
              </div>
              <div class="form-check form-check-inline form-check-lg">
                <input
                  id="vanishingTwinSyndromeIsDetectedNo"
                  class="form-check-input me-2"
                  type="radio"
                  formControlName="isDetected"
                  [attr.data-cy]="
                    ServiceDataFields.VanishingTwinSyndrome + '-radio-no'
                  "
                  [value]="false"
                />
                <label
                  class="form-check-label"
                  for="vanishingTwinSyndromeIsDetectedNo"
                >
                  {{ 'common.no' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-6 col-md-8">
            <app-validation-error
              for="isDetected"
              translations="validation.generic"
              [attr.data-cy]="
                ServiceDataFields.VanishingTwinSyndrome + '-validation-error'
              "
            ></app-validation-error>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3">
        @if (form.get('vanishingTwinSyndrome.isDetected').value) {
          <div
            class="row align-items-center"
            formGroupName="detectedGestationAge"
          >
            <div class="col-12 col-sm-4 mb-1">
              <label>
                {{ 'serviceData.form.vtsGestationAge' | translate }}
              </label>
            </div>
            <div class="col-12 col-sm-8">
              <div class="row m-0">
                <div class="col-6 ps-0">
                  <input
                    class="form-control"
                    type="number"
                    formControlName="week"
                    data-cy="VanishingTwinSyndromeWeek-input"
                    [placeholder]="
                      'serviceData.form.placeholders.gestationAgeWeek'
                        | translate
                    "
                  />
                </div>
                <div class="col-6 pe-0">
                  <input
                    class="form-control"
                    type="number"
                    formControlName="day"
                    data-cy="VanishingTwinSyndromeDay-input"
                    [placeholder]="
                      'serviceData.form.placeholders.gestationAgeDay'
                        | translate
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row justify-content-end m-0 p-0">
              <div class="col-6 col-sm-4">
                <app-validation-error
                  for="week"
                  translations="serviceData.form.validation.vtsGestationAge"
                  data-cy="VanishingTwinSyndromeWeek-validation-error"
                ></app-validation-error>
              </div>
              <div class="col-6 col-sm-4">
                <app-validation-error
                  for="day"
                  translations="validation.generic"
                  data-cy="VanishingTwinSyndromeDay-validation-error"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </ng-container>
}
